
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isDesktop: { type: Boolean, default: false },
  },
});
